import { useEffect, useState } from "react";
import Bio from "./Bio";
import AddHobbies from "./AddHobbies";
import AddFeatured from "./AddFeatured";
import "./style.css";
import axios from "axios";
import { useSelector } from "react-redux";
import EditDetails from "./EditDetails";
export default function Intro({ detailss, visitor, setOthername, onEditDetailsOpen }) {
  const { user } = useSelector((state) => ({ ...state }));
  const [details, setDetails] = useState();
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    setDetails(detailss);
    setInfos(detailss);
  }, [detailss]);
  const initial = {
    bio: details?.bio ? details.bio : "",
    otherName: details?.otherName ? details.otherName : "",
    job: details?.job ? details.job : "",
    workplace: details?.workplace ? details.workplace : "",
    highSchool: details?.highSchool ? details.highSchool : "",
    college: details?.college ? details.college : "",
    currentCity: details?.currentCity ? details.currentCity : "",
    hometown: details?.hometown ? details.hometown : "",
    relationship: details?.relationship ? details.relationship : "",
    instagram: details?.instagram ? details.instagram : "",
    hobbies: details?.hobbies ? details.hobbies : [],
    featured: details?.featured ? details.featured : [],
  };
  const [infos, setInfos] = useState(initial);
  const [showBio, setShowBio] = useState(false);
  const [showHobbies, setShowHobbies] = useState(false);
  const [showFeatured, setShowFeatured] = useState(false);
  const [max, setMax] = useState(infos?.bio ? 100 - infos?.bio.length : 100);

  const updateDetails = async (partialUpdate = null) => {
    try {
      const updateData = partialUpdate || infos;
      console.log("Updating details:", updateData);
      
      // If partial update, merge with existing infos
      const finalInfos = partialUpdate ? { ...infos, ...partialUpdate } : infos;
      
      const { data } = await axios.put(
        `/updateDetails`,
        {
          infos: finalInfos,
        },
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      console.log("Update response:", data);
      setShowBio(false);
      setDetails(data);
      setOthername(data.otherName);
      // Also update infos state to reflect the saved data
      setInfos({
        bio: data.bio || "",
        otherName: data.otherName || "",
        job: data.job || "",
        workplace: data.workplace || "",
        highSchool: data.highSchool || "",
        college: data.college || "",
        currentCity: data.currentCity || "",
        hometown: data.hometown || "",
        relationship: data.relationship || "",
        instagram: data.instagram || "",
        hobbies: data.hobbies || [],
        featured: data.featured || [],
      });
    } catch (error) {
      console.error("Details update error:", error);
      alert(error.response?.data?.message || "Failed to update details. Please try again.");
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInfos({ ...infos, [name]: value });
    setMax(100 - e.target.value.length);
  };
  return (
    <div className="profile_card">
      <div className="profile_card_header">Intro</div>
      {details?.bio && !showBio && (
        <div className="info_col">
          <span className="info_text">{details?.bio}</span>
          {!visitor && (
            <button
              className="gray_btn hover1"
              onClick={() => setShowBio(true)}
            >
              Edit Bio
            </button>
          )}
        </div>
      )}
      {!details?.bio && !showBio && !visitor && (
        <button
          className="gray_btn hover1 w100"
          onClick={() => setShowBio(true)}
        >
          Add Bio
        </button>
      )}
      {showBio && !visitor && (
        <Bio
          infos={infos}
          max={max}
          handleChange={handleChange}
          setShowBio={setShowBio}
          updateDetails={updateDetails}
          placeholder="Add Bio"
          name="bio"
        />
      )}
      {details?.job && details?.workplace ? (
        <div className="info_profile">
          <img src="../../../icons/job.png" alt="" />
          works as {details?.job} at <b>{details?.workplace}</b>
        </div>
      ) : details?.job && !details?.workplace ? (
        <div className="info_profile">
          <img src="../../../icons/job.png" alt="" />
          works as {details?.job}
        </div>
      ) : (
        details?.workplace &&
        !details?.job && (
          <div className="info_profile">
            <img src="../../../icons/job.png" alt="" />
            works at {details?.workplace}
          </div>
        )
      )}
      {details?.relationship && (
        <div className="info_profile">
          <img src="../../../icons/relationship.png" alt="" />
          {details?.relationship}
        </div>
      )}
      {details?.college && (
        <div className="info_profile">
          <img src="../../../icons/studies.png" alt="" />
          studied at {details?.college}
        </div>
      )}
      {details?.highSchool && (
        <div className="info_profile">
          <img src="../../../icons/studies.png" alt="" />
          studied at {details?.highSchool}
        </div>
      )}
      {details?.currentCity && (
        <div className="info_profile">
          <img src="../../../icons/home.png" alt="" />
          Lives in {details?.currentCity}
        </div>
      )}
      {details?.hometown && (
        <div className="info_profile">
          <img src="../../../icons/home.png" alt="" />
          From {details?.hometown}
        </div>
      )}
      {details?.instagram && (
        <div className="info_profile">
          <img src="../../../icons/instagram.png" alt="" />
          <a
            href={`https://www.instagram.com/${details?.instagram}`}
            target="_blank"
            rel="noreferrer"
          >
            {details?.instagram}
          </a>
        </div>
      )}
      {!visitor && (
        <button
          className="gray_btn hover1 w100"
          onClick={() => {
            setVisible(true);
            onEditDetailsOpen?.(true);
          }}
        >
          Edit Details
        </button>
      )}
      {visible && !visitor && (
        <EditDetails
          details={details}
          handleChange={handleChange}
          updateDetails={updateDetails}
          infos={infos}
          setVisible={(v) => {
            setVisible(v);
            if (!v) onEditDetailsOpen?.(false);
          }}
        />
      )}

      {/* Hobbies Section */}
      {details?.hobbies && details.hobbies.length > 0 && (
        <div className="hobbies_display">
          <div className="info_profile">
            <i className="hobbies_icon"></i>
            <strong>Hobbies</strong>
          </div>
          <div className="hobbies_display_list">
            {details.hobbies.map((hobby, index) => (
              <span key={index} className="hobby_display_tag">
                {hobby}
              </span>
            ))}
          </div>
          {!visitor && (
            <button
              className="gray_btn hover1 w100"
              onClick={() => setShowHobbies(true)}
            >
              Edit Hobbies
            </button>
          )}
        </div>
      )}
      {!details?.hobbies?.length && !visitor && (
        <button
          className="gray_btn hover1 w100"
          onClick={() => setShowHobbies(true)}
        >
          Add Hobbies
        </button>
      )}
      {showHobbies && !visitor && (
        <AddHobbies
          hobbies={details?.hobbies || []}
          updateDetails={updateDetails}
          setShowHobbies={setShowHobbies}
        />
      )}

      {/* Featured Section */}
      {details?.featured && details.featured.length > 0 && (
        <div className="featured_display">
          <div className="info_profile">
            <i className="featured_icon"></i>
            <strong>Featured</strong>
          </div>
          <div className="featured_display_list">
            {details.featured.map((item, index) => (
              <div key={index} className="featured_display_item">
                <span className="featured_display_icon">
                  {item.type === 'work' ? '💼' : 
                   item.type === 'education' ? '🎓' : 
                   item.type === 'achievement' ? '🏆' : 
                   item.type === 'project' ? '🚀' : '⭐'}
                </span>
                <div className="featured_display_content">
                  <div className="featured_display_title">{item.title}</div>
                  {item.description && (
                    <div className="featured_display_description">{item.description}</div>
                  )}
                  {item.link && (
                    <a href={item.link} target="_blank" rel="noopener noreferrer" className="featured_link">
                      View Link
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
          {!visitor && (
            <button
              className="gray_btn hover1 w100"
              onClick={() => setShowFeatured(true)}
            >
              Edit Featured
            </button>
          )}
        </div>
      )}
      {!details?.featured?.length && !visitor && (
        <button
          className="gray_btn hover1 w100"
          onClick={() => setShowFeatured(true)}
        >
          Add Featured
        </button>
      )}
      {showFeatured && !visitor && (
        <AddFeatured
          featured={details?.featured || []}
          updateDetails={updateDetails}
          setShowFeatured={setShowFeatured}
        />
      )}
    </div>
  );
}
